/* stylelint-disable */
// TODO:
import styled, { css } from 'styled-components';
import { primary, secondary, tertiary } from '../../tokens';
import { Body1, Body2, ParagraphText1, ParagraphText2, Headline1, Headline2, Headline3, Footnote1, Footnote2 } from '../Typography';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Card/CardTypography');
var views = {
  primary: primary,
  secondary: secondary,
  tertiary: tertiary
};

var linesMixin = function linesMixin(_ref) {
  var _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 2 : _ref$lines;
  return css(["display:-webkit-box;overflow:hidden;box-sizing:border-box;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], lines);
};

var viewMixin = function viewMixin(_ref2) {
  var _ref2$view = _ref2.view,
      view = _ref2$view === void 0 ? 'primary' : _ref2$view;
  return css(["transition:", ";color:", ";"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.lowPerformance ? 'unset' : 'color 0.1s ease-in-out';
  }, views[view]);
};

export var CardHeadline1 = /*#__PURE__*/styled(Headline1).withConfig({
  componentId: "plasma__sc-zyrk75-0"
})(["", ";"], viewMixin);
export var CardHeadline2 = /*#__PURE__*/styled(Headline2).withConfig({
  componentId: "plasma__sc-zyrk75-1"
})(["", ";"], viewMixin);
export var CardHeadline3 = /*#__PURE__*/styled(Headline3).withConfig({
  componentId: "plasma__sc-zyrk75-2"
})(["", ";"], viewMixin);
export var CardFootnote1 = /*#__PURE__*/styled(Footnote1).withConfig({
  componentId: "plasma__sc-zyrk75-3"
})(["", ";"], viewMixin);
export var CardFootnote2 = /*#__PURE__*/styled(Footnote2).withConfig({
  componentId: "plasma__sc-zyrk75-4"
})(["", ";"], viewMixin);
export var CardBody1 = /*#__PURE__*/styled(Body1).withConfig({
  componentId: "plasma__sc-zyrk75-5"
})(["", ";", ";"], linesMixin, viewMixin);
export var CardBody2 = /*#__PURE__*/styled(Body2).withConfig({
  componentId: "plasma__sc-zyrk75-6"
})(["", ";", ";"], linesMixin, viewMixin);
export var CardParagraph1 = /*#__PURE__*/styled(ParagraphText1).withConfig({
  componentId: "plasma__sc-zyrk75-7"
})(["", ";", ";"], linesMixin, viewMixin);
export var CardParagraph2 = /*#__PURE__*/styled(ParagraphText2).withConfig({
  componentId: "plasma__sc-zyrk75-8"
})(["", ";", ";"], linesMixin, viewMixin);